import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID as string;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string;

export const API_SCOPE = import.meta.env.VITE_API_SCOPE as string;
export const API_BASE = (import.meta.env.VITE_API_BASE as string) || "/api";

// Authorization Code flow + PKCE (MSAL default for SPA). No client secret here.
export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: false },
};

export const loginRequest = { scopes: [API_SCOPE] };

export const msalInstance = new PublicClientApplication(msalConfig);

export type AppRole = "Administrator" | "Reader";

// Entra App Role values may be ADMIN/READER etc.; normalize to canonical roles.
const ROLE_ALIASES: Record<string, AppRole> = {
  administrator: "Administrator", admin: "Administrator",
  reader: "Reader", read: "Reader",
};

export function rolesFromClaims(claims: Record<string, unknown> | undefined): AppRole[] {
  const raw = (claims?.roles as string[] | undefined) ?? [];
  const mapped = raw.map((r) => ROLE_ALIASES[String(r).trim().toLowerCase()]).filter(Boolean);
  return Array.from(new Set(mapped)) as AppRole[];
}
